<template>
  <div class="order-list">
    <van-nav-bar
      title="编辑抬头"
      left-arrow
      @click-left="$router.back()"
    />
    <van-form @submit="handleSaveInvoiceInfo">
      <h2 class="title">票据类型</h2>
      <div class="van-address-edit">
        <div class="van-address-edit__fields">
          <van-field name="form.type" label="票据类型" required>
            <template #input>
              <van-radio-group v-model="form.type_tag" direction="horizontal">
                <van-radio name="2">公司</van-radio>
                <van-radio name="1">个人</van-radio>
              </van-radio-group>
            </template>
          </van-field>
        </div>
      </div>
      <h2 class="title">票据信息</h2>
      <div class="van-address-edit">
        <div class="van-address-edit__fields">
          <base-textarea v-model="form.payer" :show-word-limit="false" label="票据抬头" placeholder=" " required />
          <base-textarea v-if="form.type_tag === '2'" v-model="form.tax_num"
                         :show-word-limit="false" label="统一社会信用代码" placeholder=" " required />
          <van-field name="form.type" label="设置默认">
            <template #input>
              <van-checkbox v-model="form.is_default_invoice" />
            </template>
          </van-field>
        </div>
      </div>
      <h2 class="title">收票人信息</h2>
      <div class="van-address-edit">
        <div class="van-address-edit__fields">
          <base-input type="digit" v-model="form.mobile" label="收件手机" placeholder=" " required
                      maxlength="11" :rules="[{ validator: Utils.validMobile, message: '手机号输入有误' }]"
          />
          <base-input v-model="form.email" label="收件邮箱" placeholder=" " />
        </div>
      </div>
      <div class="van-address-list__bottom">
        <base-button size="large" type="danger" native-type="submit" :round="true">保 存</base-button>
      </div>
    </van-form>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { addMemberInvoice, modifyMemberInvoice, setDefaultMemberInvoice } from '@/api/wx-fwh'
export default {
  name: 'WxEditInvoiceInfo',
  data() {
    return {
      form: {
        id: 0,
        type_tag: '2',
        type: 2,
        payer: '',
        tax_num: '',
        addr: '',
        bank: '',
        mobile: '',
        email: '',
        is_default_invoice: true,
        is_default: 1,
        member_id: null
      }
    }
  },
  computed: {
    ...mapGetters(['userInfo'])
  },
  mounted() {
    const data = localStorage.getItem('selectedInvoiceInfo')
    if (data) {
      const invoiceInfo = JSON.parse(data)
      Object.assign(this.form, invoiceInfo)
      this.form.type_tag = this.form.type.toString()
      this.form.is_default_invoice = this.form.is_default === 1
      localStorage.removeItem('selectedInvoiceInfo')
    } else {
      this.form.member_id = this.userInfo.id
    }
  },
  methods: {
    handleSaveInvoiceInfo() {
      this.form.type = parseInt(this.form.type_tag)
      this.form.is_default = this.form.is_default_invoice ? 1 : 2
      if (this.form.id) {
        modifyMemberInvoice(this.form).then(resp => {
          this.alert(resp.msg)
          setDefaultMemberInvoice({
            id: this.form.id,
            is_default: this.form.is_default
          })
        }).catch(resp => {
          this.alert(resp.msg)
        })
      } else {
        addMemberInvoice(this.form).then(resp => {

          this.form.id = resp.obj.id
          this.alert(resp.msg)
          setDefaultMemberInvoice({
            id: this.form.id,
            is_default: this.form.is_default
          })
        }).catch(resp => {
          this.alert(resp.msg)
        })
      }
    }
  }
}
</script>

<style scoped>
  .order-list {
    color: #323233;
    font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
      Helvetica, Segoe UI, Arial, Roboto, 'PingFang SC', 'Hiragino Sans GB', 'Microsoft Yahei', sans-serif;
  }
  .title {
    margin: 0;
    padding: 10px 16px 0px;
    color: rgba(69, 90, 100, 0.6);
    font-weight: normal;
    font-size: 14px;
    line-height: 5px;
  }
</style>



// WEBPACK FOOTER //
// src/components/wxfwh/apply-invoice/wx-edit-invoice-info.vue